import React, {Fragment, useState, useEffect } from 'react';

import {motion} from 'framer-motion';
import axios from 'axios';
import  ListDataPrductsForDemo from './dataProducts'

import URL from '../../config/config-server-api';

import './mainShowProductHome.css'
import ShowDetailProdcut from '../showDetailProduct/showDetailProduct';

const MainShowProductHome =({category, shoppingCart, handleShoppingCart, handleStateViewdDetail, TIENDA})=>{

    const [dataProducts, setDataProducts] = useState([]);
    const [moreListProduct, setMoreListProduct] = useState(20);

    useEffect(()=>{
       
        // requestApi();
        setListProducts(category)

    },[category])

    // const requestApi = async (cantRequest=0) => {
    //     try {
    //         const url = `${URL.UrlShowProductAddedRecnet}${moreListProduct}&skip=0`;
    //         const { data } = await axios.get(url);
    //         console.log(data)
    //         setDataProducts(data.lisProducts)
            
            
    //     } catch (error) {
    //         console.log('error en el acceso a la API')
    //         console.log({numeroIntento:cantRequest})
    //         if(cantRequest>5){
    //             return '';
    //         }
    //         requestApi(cantRequest+1)
    //     }
    // }

    const cardBody ={
        title: "Para hombres Rolex Oyster Perpetual Datejust 36mm Rojo Brillante Cuadrante romano reloj de Diamante",
        precio: 120,
        envios: "potosi"
    }
    // Lista de products
    const [listProcts, setListProducts]= useState([])
    
    const [showModalDetail, setShowModaDetail]= useState(false);
    const [product, setProduct] = useState(0);
    
    const modalstate =()=>{
        setShowModaDetail(!showModalDetail);
    }

    const handleProduct =({numberItem})=>{
        // console.log(numberItem);
        setProduct(numberItem)
        setShowModaDetail(!showModalDetail)
    }


    return (
        <Fragment>
            {/* <div id="title-seccion" className="px-10 bg-white text-gray-500 text-xl font-bold  capitalize">Productos recientemente agragados</div> */}

        <div id="constent-iten-product" className=" container  rounded  flex wrap grid grid-cols-2 sm:grid-cols-3  md:grid-cols-3  lg:grid-cols-4 justify-items-stretch gap-1 gap-y-3 sm:gap-5 w-full mt-3">
                {/* listProcts.length!=0? */}

            {
                listProcts.length!=0?
                listProcts.map((d,i)=>{
                    return(
                        <motion.div id="item-product" onClick={()=>handleProduct({numberItem:i})} key={d+i} whileHover={{ scale:1.04 }} whileTap={{scale:0.9}}  className="shadow relative hover:shadow-xl rounded-lg bg-white h-auto w-11/12 md:w-11/12 my-5  mx-2 mx-auto">
                            <div className="rounded-lg bg-white bg-opacity-75 w-full h-36 sm:h-52">
                                <motion.img key={i} initial={{opacity:0}} animate={{opacity:1}} src={d.fotoProducto} className="rounded-lg w-auto h-full m-auto" alt="" />
                                {/* <div className="top-0 left-0 absolute text-indigo-500 bg-gray-200">{i}</div> */}
                            </div>
                            <div id="card-body" className="mx-auto   px-2 pb-2">
                                <div className="text-base font-bold text-gray-500 text-left leading-tight py-2">{d?.nameProduct?.substr(0,36)}</div>
                                <div className="text-xs line-through  font-bold text-gray-500">{TIENDA?.country?.currenciesMoneda} {d.priceBefore}</div>
                                <div className="text-lg font-bold text-gray-900">{TIENDA?.country?.currenciesMoneda} {d.priceCurrent}</div>
                                {/* <div className="text-sm text-gary-400 capitalize">{cardBody.envios}</div> */}
                                <div className="flex flex-row-reverse text-green-500 ">
                                    {/* <div >89 <span className="hidden sm:inline">vistas</span> </div> */}
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-green-500 my-auto " fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                    </svg>
                                </div>
                            </div>
                        </motion.div>
                    )
                })
                :
                ListDataPrductsForDemo.map((d,i)=>{
                    return(
                        <motion.div id="item-product"  key={d+i} whileHover={{ scale:1.04 }} whileTap={{scale:0.9}}  className="shadow relative hover:shadow-xl rounded-lg bg-white h-auto w-11/12 md:w-11/12 my-5  mx-2 mx-auto">
                            <div className="rounded-lg bg-white bg-opacity-75 w-full h-36 sm:h-52">
                                <motion.img key={i} initial={{opacity:0}} animate={{opacity:1}} src='https://mybuecket-test1.s3.amazonaws.com/loading-card-img.gif' className="rounded-lg w-auto h-full m-auto" alt="" />
                                {/* <div className="top-0 left-0 absolute text-indigo-500 bg-gray-200">{i}</div> */}
                            </div>
                            <div id="card-body" className="mx-auto   px-2 pb-2">
                                <div className="text-base font-bold text-gray-500 text-left leading-tight py-2">{d?.nameProduct?.substr(0,36)}</div>
                                <div className="text-xs line-through  font-bold text-gray-500">{TIENDA?.country?.currenciesMoneda} {d.priceBefore}</div>
                                <div className="text-lg font-bold text-gray-900">{TIENDA?.country?.currenciesMoneda} {d.priceCurrent}</div>
                                {/* <div className="text-sm text-gary-400 capitalize">{cardBody.envios}</div> */}
                                <div className="flex flex-row-reverse text-green-500 ">
                                    {/* <div >89 <span className="hidden sm:inline">vistas</span> </div> */}
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-green-500 my-auto " fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                    </svg>
                                </div>
                            </div>
                        </motion.div>
                    )
                })
            }

            {
                showModalDetail?
                <div id="modal-detail-container" key="modal" className="fixed  flex-jsutify-center z-20 top-0 left-0 bottom-0 h-full w-full bg-opacity-50 bg-gray-900">
                        <ShowDetailProdcut modalstate={modalstate} dataProduct={listProcts[product]}  handleShoppingCart={handleShoppingCart} handleStateViewdDetail={handleStateViewdDetail} TIENDA={TIENDA}  />
                </div>
                :
                ''
            }
            
                
        </div>
        </Fragment>

    )
}


export default MainShowProductHome;